<template>
  <div class="container-fluid">
    <div class="row mb-3">
      <div class="col-sm-12 text-center">
        <h1 class="title">
          Gic Customer portal
        </h1>
      </div>
      <div class="col-sm-12">
        <button type="button" class="btn btn-primary" @click="sapEvent">Sap event</button>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-lg-3 ins-product d-flex justify-content-center">
        <div class="product-icon-rounded d-flex justify-content-center align-items-center flex-grow-0 flex-shrink-0 cursor-pointer" @click="$router.push({name: 'Motor'})">
           <svg class="svg-icon svg-icon--product">
            <use xlink:href="@/assets/img/MOTOR.svg#MOTOR"></use>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios';
import { SAP_USERNAME, SAP_PASSWORD } from '@/shared/config';

export default {
  methods: {
    async sapEvent() {
      const response = await axios.get('zapi_tests/motor_init_test', {
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        headers: {
          Authorization: `Basic ${btoa(`${SAP_USERNAME}:${SAP_PASSWORD}`)}`,
          'X-CSRF-Token': 'fetch',
          'sap-client': '200',
          'sap-language': 'EL'
        }
      });
      console.log(response);
    },
  },

};
</script>
